<template>
  <v-dialog v-model="dialog" max-width="400" scrim="rgba(20, 32, 28, 0.65)">
    <v-card class="donate-modal" rounded="lg">
      <div class="donate-modal__header">
        <div>
          <p class="donate-modal__eyebrow">Support BHMLF</p>
          <h2 class="donate-modal__title">Donate with Venmo</h2>
        </div>
        <v-btn
          icon
          variant="text"
          size="small"
          aria-label="Close"
          @click="dialog = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <v-card-text class="donate-modal__body">
        <p class="donate-modal__lead">
          Scan the QR code on desktop, or open Venmo on your phone. Gifts
          support education, conservation, and our annual banquet.
        </p>

        <div class="donate-modal__qr">
          <img
            :src="venmoQrUrl"
            alt="Venmo QR code for Black Hills Mountain Lion Foundation"
            width="220"
            height="220"
          />
        </div>

        <div class="donate-modal__actions">
          <v-btn
            :href="venmoUrl"
            color="primary"
            variant="flat"
            block
            size="large"
            target="_blank"
            rel="noopener noreferrer"
          >
            Open Venmo
          </v-btn>
          <v-btn variant="text" block @click="dialog = false">Close</v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DonateModal",
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    venmoUrl: {
      type: String,
      required: true,
    },
    venmoQrUrl: {
      type: String,
      required: true,
    },
  },
  emits: ["update:modelValue"],
  computed: {
    dialog: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
};
</script>

<style scoped>
.donate-modal {
  overflow: hidden;
  border: 1px solid var(--bh-border, #c9d0cb);
}

.donate-modal__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 1.25rem 1.25rem 0;
}

.donate-modal__eyebrow {
  margin: 0 0 0.25rem;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--bh-amber, #c17a2f);
}

.donate-modal__title {
  margin: 0;
  font-family: var(--bh-font-display, "Outfit", system-ui, sans-serif);
  font-size: 1.35rem;
  font-weight: 600;
  line-height: 1.25;
  color: var(--bh-forest, #1e3a2f);
  letter-spacing: -0.01em;
}

.donate-modal__body {
  padding: 1rem 1.25rem 1.35rem !important;
}

.donate-modal__lead {
  margin: 0 0 1.25rem;
  text-align: center;
  color: var(--bh-muted, #5c6560);
  font-size: 0.95rem;
  line-height: 1.5;
}

.donate-modal__qr {
  display: flex;
  justify-content: center;
  margin-bottom: 1.25rem;
}

.donate-modal__qr img {
  width: 220px;
  height: 220px;
  object-fit: contain;
  background: #fff;
  border: 1px solid var(--bh-border, #c9d0cb);
  border-radius: 12px;
  padding: 0.75rem;
}

.donate-modal__actions {
  display: grid;
  gap: 0.35rem;
}
</style>
